
import React, { memo } from 'react';
import { Point3D, Orientation } from '../types';
import { project } from '../utils/isometricMath';

interface FaceRendererProps {
  position: Point3D;
  rotation: { x: number, y: number };
  orientation: Orientation;
  color: string;
  transparent?: boolean;
}

export const FaceRenderer: React.FC<FaceRendererProps> = memo(({ 
  position, rotation, orientation, color, transparent 
}) => {
  const getP = (dx: number, dy: number, dz: number) => 
    project({ x: position.x + dx, y: position.y + dy, z: position.z + dz }, rotation);

  let points: any[] = [];
  if (orientation === 'top') {
    points = [getP(0,1,0), getP(1,1,0), getP(1,1,1), getP(0,1,1)];
  } else if (orientation === 'left') {
    points = [getP(0,0,0), getP(0,0,1), getP(0,1,1), getP(0,1,0)];
  } else {
    points = [getP(0,0,0), getP(1,0,0), getP(1,1,0), getP(0,1,0)];
  }

  return (
    <path 
      d={`M ${points[0].x} ${points[0].y} L ${points[1].x} ${points[1].y} L ${points[2].x} ${points[2].y} L ${points[3].x} ${points[3].y} Z`}
      fill={color}
      stroke="rgba(0,0,0,0.15)"
      strokeWidth="0.5"
      fillOpacity={transparent ? 0.3 : 1}
    />
  );
});
